import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Badge,
  FormGroup,
  Label,
  Form,
} from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import TableContainer from "../../../../components/Common/TableContainer";
import { FaCheck } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchClaimApprovals, fetchOnboardingJobApproveList, fetchViewClaimList, saveClaimApproval, saveOnboardingJobApprove } from "store/actions";
import Loader from "common/pageLoader";
import CustomDatePicker from "common/CustomDatePicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";

const badgeStyle = {
  minWidth: '40px',
  height: '35px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '14px',
  borderRadius: '20%',
};

const sampleData = [
  {
    claim_id: 101,
    emp_name: "John Doe",
    claim_date: "2025-07-20",
    head_name: "HR Department",
    subheads_name: "Recruitment",
    amount: "M.Sc HR",
    claim_status: "₹50,000",
    approval_level: "3 Years",
    selectedOption: "Approve", // can be "Approve", "Reject", or "Discussion"
    approval_remarks: "Eligible for role",
    b_active: 1,
    file_path: "/uploads/resume_john_doe.pdf",
  },
  {
    claim_id: 102,
    emp_name: "Anita Verma",
    claim_date: "2025-07-19",
    head_name: "Finance",
    subheads_name: "Payroll",
    amount: "MBA Finance",
    claim_status: "₹70,000",
    approval_level: "5 Years",
    selectedOption: "Reject",
    approval_remarks: "Overqualified",
    b_active: 0,
    file_path: "/uploads/resume_anita_verma.pdf",
  },
  {
    claim_id: 103,
    emp_name: "Ravi Kumar",
    claim_date: "2025-07-18",
    head_name: "Tech",
    subheads_name: "Development",
    amount: "B.Tech CSE",
    claim_status: "₹40,000",
    approval_level: "2 Years",
    selectedOption: "Discussion",
    approval_remarks: "Needs second round",
    b_active: 1,
    file_path: "/uploads/resume_ravi_kumar.pdf",
  }
];


const OnboardingApplyJobApprove = () => {
  const [data, setData] = useState([]);
  const [counts, setCounts] = useState({
    Approve: 0,
    Reject: 0,
    Discussion: 0,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    approveList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    approveList: state.RecruitmentOnboardingReducer?.approveList ?? [],

    loading: state.RecruitmentOnboardingReducer?.loading,
    error: state.RecruitmentOnboardingReducer?.error,
    success: state.RecruitmentOnboardingReducer?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
  }, [dispatch]);

   useEffect(() => {
      if (authDetails) {
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
    }, [authDetails]);


  useEffect(() => {
    if (approveList && approveList.length > 0) {
      const initializedData = (approveList || []).map(row => ({
        ...row,
        selectedOption: null,
        remarks: ""
      }));
      setData(initializedData)
    }
  }, [approveList])

  useEffect(() => {
    if (success) {
      dispatch(fetchOnboardingJobApproveList(authDetails?.unit_id));
      setCounts({
        Approve: 0,
        Reject: 0,
        Discussion: 0,
      })
    }
  }, [authDetails, success, dispatch]);

  const handleRemarksChange = (applicant_id, value) => {
    const updatedData = (data || []).map((item) =>
      item.applicant_id === applicant_id ? { ...item, remarks: value } : item
    );
    setData(updatedData);
  };

  const handleCancel = () => {
    const resetData = data.map((item) => ({
      ...item,
      selectedOption: null,
      remarks: "",
    }));
    setData(resetData);
    setCounts({
      Approve: 0,
      Reject: 0,
      Discussion: 0,
    })
    formik.resetForm()
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleView = (row) => {
    // setSelectedRow(row);
    dispatch(fetchViewClaimList(authDetails?.unit_id, row.claim_id))
    toggleModal();
  };

  const handleAttach = (row) => {
    if (row.file) {
      alert(`File Attached: ${row.file.name}`);
    } else {
      alert("No File Uploaded");
    }
  };

  const handleOptionChange = (rowId, action) => {
    const updatedData = data.map((row) => {
      if (row.applicant_id === rowId) {
        return { ...row, selectedOption: action };
      }
      return row;
    });

    setData(updatedData);
  };

  const handleBulkActionChange = (action) => {
    const updatedData = data.map((row) => ({
      ...row,
      selectedOption: action,
    }));
    setData(updatedData);
  };

  const columns = [
    {
      Header: "S.No",
      Cell: ({ row }) => data.length - row.index,
      className: "serial-no",
      applyHeaderClass: true,
    },
    { Header: "Name", accessor: "applicant_name" },
    { Header: "Position", accessor: "job_code" },
    { Header: "Email", accessor: "email" },
    { Header: "Mobile", accessor: "mobile_no" },
    { Header: "Qualification", accessor: "qualification" },
    { Header: "Expected Sal.", accessor: "expected_salary" },
    { Header: "Previous Designation", accessor: "experience" },
    {
      id: "approve",
      Header: () => (
        <div className="text-center">
          Approve <br />
          <Input
            type="radio"
            name="selectAll"
            onChange={() => handleBulkActionChange("Approve")}
          />
        </div>
      ),
      Cell: ({ row }) => (
        <div
          className="d-flex justify-content-center align-items-center"
          onClick={() => handleOptionChange(row.original.applicant_id, "Approve")}
          style={{ cursor: "pointer" }}
        >
          {row.original.selectedOption === "Approve" ? (
            <FaCheck color="green" size={20} />
          ) : (
            <Input
              type="radio"
              name={`action-${row.original.applicant_id}`}
              onChange={() => handleOptionChange(row.original.applicant_id, "Approve")}
              checked={row.original.selectedOption === "Approve"}
            />
          )}
        </div>
      ),
    },
    {
      id: "reject",
      Header: () => (
        <div className="text-center">
          Reject <br />
          <Input
            type="radio"
            name="selectAll"
            onChange={() => handleBulkActionChange("Reject")}
          />
        </div>
      ),
      Cell: ({ row }) => (
        <div
          className="d-flex justify-content-center align-items-center"
          onClick={() => handleOptionChange(row.original.applicant_id, "Reject")}
          style={{ cursor: "pointer" }}
        >
          {row.original.selectedOption === "Reject" ? (
            <FaCheck color="red" size={20} />
          ) : (
            <Input
              type="radio"
              name={`action-${row.original.applicant_id}`}
              onChange={() => handleOptionChange(row.original.applicant_id, "Reject")}
              checked={row.original.selectedOption === "Reject"}
            />
          )}
        </div>
      ),
    },
    {
        id: "discussion",
        Header: () => (
        <div className="text-center">
          None <br />
          <Input
            type="radio"
            name="selectAll"
            onChange={() => handleBulkActionChange("Discussion")}
          />
        </div>
      ),
      Cell: ({ row }) => (
        <div
          className="d-flex justify-content-center align-items-center"
          onClick={() => handleOptionChange(row.original.applicant_id, "Discussion")}
          style={{ cursor: "pointer" }}
        >
          {row.original.selectedOption === "Discussion" ? (
            <FaCheck color="orange" size={20} />
          ) : (
            <Input
              type="radio"
              name={`action-${row.original.applicant_id}`}
              onChange={() => handleOptionChange(row.original.applicant_id, "Discussion")}
              checked={row.original.selectedOption === "Discussion"}
            />
          )}
        </div>
      ),
    },
    {
      Header: "Remarks",
      Cell: ({ row }) => {
        const [value, setValue] = useState(row.original.remarks || "");

        const handleBlur = () => {
          if (value !== row.original.remarks) {
            handleRemarksChange(row.original.applicant_id, value);
          }
        };

        return (
          <Input
            type="text"
            bsSize="sm"
            placeholder="Enter remarks"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onBlur={handleBlur}
          />
        );
      }
    },
  ];

  const validationSchema = Yup.object({
      fromDate: Yup.date()
        .required("From Date is required"),
  
      toDate: Yup.date()
        .required("To Date is required")
        .test(
          "is-before-fromDate",
          "To Date cannot be before From Date",
          function (value) {
            const { fromDate } = this.parent;
            return !fromDate || !value || new Date(value) >= new Date(fromDate);
          }
        )
    });

 const formik = useFormik({
    initialValues: {
      fromDate: "",
      toDate: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log('values > ',values)
      const formData = new FormData();
      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);
      dispatch(fetchOnboardingJobApproveList(formData));   
    },
  });

  const handleSave = () => {
    const updatedClaims = (data || [])
      .filter(item => item.selectedOption !== null && item.selectedOption !== undefined)
      .map(item => {
        const approvalStatusMap = {
          Approve: "1",
          Reject: "2",
          Discussion: "3"
        };

        return {
          applicant_id: item.applicant_id,
          rec_approval_status: approvalStatusMap[item.selectedOption] || "0",
          rec_approval_remarks: item.remarks || ""
        };
      });

    if (!updatedClaims.length) {
      Swal.fire({
        icon: "warning",
        title: "No Selection",
        text: "Please select at least one before proceeding."
      });
      return;
    }

    const payload = { rec: updatedClaims };
    const formData = new FormData();
    formData.append("lst_rec_approval", JSON.stringify(payload));
    formData.append("create_by", authDetails?.user_id);

    dispatch(saveOnboardingJobApprove(formData));
  };

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Onboarding" breadcrumbItem="Apply Job Approval" />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row >
                {/* From Date */}
                <Col md={3} sm={12} className="mb-3">
                  <FormGroup>
                    <Label for="fromDate">From Date <span className="text-danger">*</span></Label>
                    <CustomDatePicker
                      name="fromDate"
                      value={formik.values.fromDate}
                      onChange={(date) => formik.setFieldValue("fromDate", date)}
                      onBlur={formik.handleBlur}
                      // disableFuture={true}
                      className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                    />
                    {formik.touched.fromDate && formik.errors.fromDate && (
                      <div className="text-danger">{formik.errors.fromDate}</div>
                    )}
                  </FormGroup>
                </Col>

                {/* To Date */}
                <Col md={3} sm={12} className="mb-3">
                  <FormGroup>
                    <Label for="toDate">To Date <span className="text-danger">*</span></Label>
                      <CustomDatePicker
                      name="toDate"
                      value={formik.values.toDate}
                      onChange={(date) => formik.setFieldValue("toDate", date)}
                      onBlur={formik.handleBlur}
                      // disableFuture={true}
                      className={`form-control ${formik.touched.toDate && formik.errors.toDate ? "is-invalid" : ""}`}
                    />
                    {formik.touched.toDate && formik.errors.toDate && (
                      <div className="text-danger">{formik.errors.toDate}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col className="d-flex flex-wrap gap-2 mob-center align-items-center justify-content-end">
                <Button type="submit" className="btn button-search me-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-save me-2"  onClick={handleSave}>
                    <i className="fas fa-save me-1" /> Save
                  </Button>
                  <Button type="reset" className="btn button-cancel"  onClick={handleCancel}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
              </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={data && data.length > 0 ? data : []}
              customPageSize={10}
              className="table-striped table-bordered"
              isGlobalFilter={true}
            />
          </CardBody>
        </Card>

        {isModalOpen && viewClaimList && (
          <Modal isOpen={isModalOpen} toggle={toggleModal} size="lg" centered>
            <ModalHeader toggle={toggleModal}>Applicant Details</ModalHeader>
            <ModalBody>
              <Table className="table table-bordered">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Approval Name</th>
                    <th>Level</th>
                    <th>Status</th>
                    <th>Comment</th>
                  </tr>
                </thead>
                <tbody>
                  {viewClaimList.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.approver_name}</td>
                      <td>{item.approval_level}</td>
                      <td>{item.approval_status}</td>
                      <td>{item.approval_comment}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </ModalBody>
          </Modal>
        )}

      </Container>
    </div>
  );
};

export default OnboardingApplyJobApprove;
